import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "@store/index";
//convin - mui - theme - imports
import { SettingsProvider } from "@convin/contexts/SettingsContext";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ThemeProvider from "@convin/theme";
import ThemeColorPresets from "@convin/components/theme/ThemeColorPresets";
import ThemeSettings from "@convin/components/theme/settings";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import EditorStyle from "@convin/styleOverrides/EditorStyle";
import ChartStyle from "@convin/components/chart/ChartStyle";
import { PosthogWrapper } from "PosthogWrapper";
import VersionApiLoader from "@convin/components/custom_components/reuseable/VersionApiLoader";
import SalesAssistWidget from "@convin/components/custom_components/SalesAssistIframe/SalesAssistWidget";
import AuthProvider from "@convin/contexts/AuthContextProvider";
import ToastErrorSvg from "@convin/components/lexicalEditor/svg/ToastErrorSvg";
import ToastWarnSvg from "@convin/components/lexicalEditor/svg/ToastWarnSvg";
import ToastSuccessSvg from "@convin/components/lexicalEditor/svg/ToastSuccessSvg";
import GistStyle from "@convin/components/GistStyle";

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

root.render(
    <Provider store={store}>
        <PosthogWrapper>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <SettingsProvider>
                    <BrowserRouter>
                        <ThemeProvider>
                            <ThemeColorPresets>
                                <EditorStyle />

                                <ChartStyle />
                                {/* <ReactMentionStyles /> */}
                                <AuthProvider>
                                    <GistStyle />
                                    <VersionApiLoader>
                                        <App />
                                    </VersionApiLoader>
                                </AuthProvider>
                                <ThemeSettings />
                            </ThemeColorPresets>
                        </ThemeProvider>
                        <ToastContainer
                            position="top-right"
                            autoClose={3000}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            rtl={false}
                            style={{ direction: "ltr" }}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                            icon={({ type }) => {
                                switch (type) {
                                    case "error":
                                        return <ToastErrorSvg />;
                                    case "success":
                                        return <ToastSuccessSvg />;
                                    case "warning":
                                        return <ToastWarnSvg />;
                                    default:
                                        return null;
                                }
                            }}
                        />
                        <SalesAssistWidget />
                    </BrowserRouter>
                </SettingsProvider>
            </LocalizationProvider>
        </PosthogWrapper>
    </Provider>
);
